// ** Initial State
const initialState = {
  registrants: null, 
  transactions: null, 
  sync_transactions: null, 
  pageLoader: true,
  yearWiseComparison: null

}

const dashboard3 = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_REGISTRANTS':
      return { ...state, registrants: action.data }
    case 'GET_TRANSACTION_SYNC':
      return { ...state, transactions: action.data }
    case 'SYNC_TRANSACTION':
      return { ...state, sync_transactions: action.data }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    case 'GET_YEAR_WISE_COMPARISON':
      return { ...state, yearWiseComparison: action.data }
    default:
      return { ...state }
  }
}
export default dashboard3
